
import { supabase } from "@/integrations/supabase/client";
import { success } from "@/hooks/use-toast";
import { devLog, devError } from "@/utils/secureLogger";

export const useVerification = () => {
  const verifyOtp = async (email: string, token: string, pendingCredentials?: { email: string, password: string, username: string }) => {
    try {
      devLog("Verifying OTP for email");
      
      // Verify the OTP first
      const { data: verifyData, error: verifyError } = await supabase.auth.verifyOtp({
        email,
        token,
        type: 'email',
      });
      
      if (verifyError) throw verifyError;
      
      devLog("OTP verification successful");
      
      // Show success message after verification is complete
      success({
        title: "Email verified successfully",
        description: "Your account has been created and you are now signed in",
      });
      
      return { data: verifyData, error: null };
    } catch (err) {
      devError("Error verifying OTP:", err);
      return { data: null, error: err };
    }
  };

  const resendVerificationEmail = async (email: string) => {
    try {
      devLog("Resending verification email");
      
      // Store email temporarily for verification process (not password)
      sessionStorage.setItem('pendingVerificationEmail', email);
      
      // Resend verification email
      const { data, error: resendError } = await supabase.auth.resend({
        type: 'signup',
        email: email,
        options: {
          emailRedirectTo: window.location.origin + '/auth?verification=true',
        }
      });
      
      if (resendError) throw resendError;
      
      devLog("Verification email resent successfully");
      
      success({
        title: "Verification email resent",
        description: "Please check your email for the verification link",
      });
      
      return { data, error: null };
    } catch (err) {
      devError("Error resending verification email:", err);
      return { data: null, error: err };
    }
  };

  return { verifyOtp, resendVerificationEmail };
};
